<template>
  <div
    class="collection-card"
    onclick="this.__vue__.playPause(+this.parentElement.getAttribute('data-swiper-slide-index'));"
  >
    <div
      :class="[
        'collection-card__audio-status',
        isPlay ? 'collection-card__audio-play' : 'collection-card__audio-pause',
      ]"
    />
    <img :data-src="image" alt="" class="collection-card__image swiper-lazy" />
    <div class="swiper-lazy-preloader" />
    <div class="collection-card__title">
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'CollectionCard',
  props: {
    image: String,
    title: String,
    isPlay: Boolean,
  },
  methods: {
    playPause() {
      this.$emit('playPause', !this.isPlay);
      this.$emit('update:isPlay', !this.isPlay);
    },
  },
};
</script>
<style scoped>
.collection-card {
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
}
.collection-card::after {
  content: '';
  display: block;
  position: absolute;
  bottom: -12px;
  top: 20%;
  left: 0;
  right: 0;
  background-image: url(~IMAGES/elements/waves_in_slider.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.collection-card__image {
  display: block;
  border-radius: 10px;
  width: 100%;
  height: auto;
}
.collection-card__title {
  color: var(--button-text-color);
  position: absolute;
  z-index: 2;
  bottom: 18px;
  left: 25px;
  font-size: 24px;
}
.collection-card__audio-status {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  width: 45px;
  height: 51px;
  margin: -25.5px 0 0 -22.5px;
}
.collection-card__audio-pause {
  background-image: url(~IMAGES/icons/play.svg);
}
.collection-card__audio-play {
  background-image: url(~IMAGES/icons/pause.svg);
}
</style>
